import { Left } from 'Models/Menu/menus';
import { getView } from '@/lib/utils';

export default {
  path: '/contact-form',
  name: 'contactForm',
  component: getView('pages/PageContactForm'),
  meta: {
    crumbs: 'Information',
    leftMenu: Left.Guest,
  },
};
